import axios from "axios";
import ItemList from "./ItemList";
import Loading from "./Loading";
import SearchBar from "./SearchBar";
import Front from "./Front";
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

class Tabs extends React.Component {
    constructor(props) {
        super(props);
        let selectedTab;
        let auctionType;
        let postType;
        function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }

        let t = findGetParameter('t'); //1,2,4,5
        let f = findGetParameter('f'); //oksjonid, kuulutused, minu_kuulutused, kuulutused_pooleli, mina_myyn, mina_osalen, pooleli_olevad
        let a = findGetParameter('a');//algavad, aktiivsed, toimunud
        let type =findGetParameter('type'); // sale, rent
        console.log(`what is t=${t}, f=${f}, a=${a}, type=${type}`)
        if(f==="kuulutused") {
            if(type === "sale"){
                if(t === '1' || t==='2'){
                    selectedTab = parseFloat(t);
                }else if(t==="kv24"||t==="city24"||t==="soov"){
                    selectedTab = t;
                } else{
                    selectedTab = 1; //Sale tab
                }
            } else if(type === "rent"){
                if(t === 5 || t==="kv24"||t==="city24"||t==="soov") {
                    selectedTab = t;
                }else{
                    selectedTab = 5; //Rent tab
                }
            }
            postType = type;
        } else if(f==="oksjonid"){
            if(a === "algavad"){
                selectedTab = 501; //Starting tab 501
            }else if( a==="aktiivsed"){
                selectedTab = 502; //Ongoing tab 502
            } else if(a==="toimunud"){
                selectedTab = 503; //Ended tab 503
            } else{
                selectedTab = 502; // Active Tab 502
            }
            auctionType = t;
        } else if(f === "minu_kuulutused" ) {
            selectedTab = 1003; // Selling tab
        } else if(f=== "kuulutused_pooleli") {
            selectedTab = 1003;//Unfinished tab
        }else if(f === "mina_myyn") {
            selectedTab = 1003; // Selling tab
        } else if(f === "mina_osalen") {
            selectedTab = 1002; // Buying tab
        } else if(f === "pooleli_olevad") {
            selectedTab = 1003; //Unfinished tab
        }

        this.state = {
            selectedTab: selectedTab,
            auctionType: auctionType,
            postType: postType,
            tabs: [],
            page: '',
            fileName: '',
            keyword: '',
            keywordValue: '',
            county: '',
            minprice: '',
            maxprice: '',
            sort:'',
            sortValue:'',
            loading: true,
            refreshTabs:false,
            filterCounty: [],
            front: false,
            searchBar: false
        };
    }

    componentDidMount(postIndex = this.state.postType){

        /*===============   Link detection   ==================*/
        function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }
        let t = findGetParameter('t'); //1,2,4,5
        let f = findGetParameter('f'); //oksjonid, kuulutused, minu_kuulutused, kuulutused_pooleli, mina_myyn, mina_osalen, pooleli_olevad

        /*================= Link detection end   ================*/

        if(f=== "kuulutused"){
            /* KUULUTUSED */
            this.setState({
                page: 'post',
                searchBar: true
            })


            if(postIndex === "sale") {
                this.setState({
                    loading: false,
                    front:false,
                    sort:localStorage.getItem('sort') || '',
                    sortValue:localStorage.getItem('sortValue') || '',
                })
                axios.get('/count/post/sale')
                    .then(function (res) {
                        const count = res.data.post;
                        const countKv = res.data.kv24;
                        const countCity = res.data.city24;
                        const countSoov = res.data.soov;
                        this.setState({
                            tabs: [
                                {key: 1, name: LANG['Kasvav mets'] || 'Kasvav mets' , count: count[1], slug: "mets", fileName:'kuulutused&type=sale'},
                                {key: 2, name: LANG['Kinnistud'] || 'Kinnistud', count: count[2], slug: "kinnistud", fileName:'kuulutused&type=sale'},
                                {key: "soov", name: "soov.ee", count: countSoov, slug: "soov", fileName:'kuulutused&type=sale'},
                                {key: "kv24", name: "kinnisvara 24", count: countKv, slug: "kv24", fileName:'kuulutused&type=sale'},
                                {key: "city24", name: "city24.ee", count: countCity, slug: "city24", fileName:'kuulutused&type=sale'}
                            ],
                        });
                        if (count[1] === '0') {
                            const urlParams = new URLSearchParams(window.location.search);
                            if (urlParams.get('t') === null) { this.setState({selectedTab: 2}); }
                        }
                        if (count[2] === '0') {
                            const urlParams = new URLSearchParams(window.location.search);
                            if (urlParams.get('t') === null) { this.setState({selectedTab: 'soov'}); }
                        }
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                    });
            } else if(postIndex === "rent") {
                this.setState({
                    loading: false,
                    front:false,
                    sort:localStorage.getItem('sort') || '',
                    sortValue:localStorage.getItem('sortValue') || '',
                })
                axios.get('/count/post/rent')
                    .then(function (res) {
                        const count = res.data.post;
                        const countKv = res.data.kv24;
                        const countCity = res.data.city24;
                        const countSoov = res.data.soov;
                        this.setState({
                            tabs: [
                                {key: 5,name: LANG['Põllumaa rent'] || 'Põllumaa rent', count: count[5], slug: "pollumaa", fileName:'kuulutused&type=rent'},
                                {key: "soov", name: "soov.ee", count: countSoov, slug: "soov", fileName:'kuulutused&type=rent'},
                                {key: "kv24",name: "kinnisvara 24", count: countKv, slug: "kv24", fileName:'kuulutused&type=rent'},
                                {key: "city24",name: "city24.ee", count: countCity, slug: "city24", fileName:'kuulutused&type=rent'},
                            ],
                        });
                        if (count[5] === '0') {
                            const urlParams = new URLSearchParams(window.location.search);

                            if (urlParams.get('t') === null) {
                                this.setState({selectedTab: 'soov'});
                            }
                        }
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                    });
            } else {
                this.setState({
                    front: true,
                    loading: false,
                });
            }
        } else if(f === "oksjonid") {
            this.setState({
                page: 'auction',
            })
            if(localStorage.getItem('sortValue') !== 'cheap' || localStorage.getItem('sortValue') !== 'expensive') {
                this.setState({
                    sort:localStorage.getItem('sort') || '',
                    sortValue:localStorage.getItem('sortValue') || '',
                });
            }

            if(t !== null ) {
                this.setState({
                    loading: false,
                    front:false,
                    searchBar: true
                })
                axios.get(`/count/auction/${this.state.auctionType}/`)
                    .then(function (res) {
                        const starting = res.data.starting;
                        const running = res.data.running;
                        const ended = res.data.ended;
                        this.setState({
                            tabs: [
                                {key: 501, name: LANG['Algavad'] || 'Algavad', count:starting, slug: "starting",auctionSlug: "algavad", fileName:'oksjonid&a=algavad'},
                                {key: 502, name: LANG['Aktiivsed'] || 'Aktiivsed', count: running, slug: "running",auctionSlug: "aktiivsed", fileName:'oksjonid&a=aktiivsed'},
                                {key: 503, name: LANG['Toimunud'] || 'Toimunud', count: ended, slug: "ended",auctionSlug: "toimunud", fileName:'oksjonid&a=toimunud'},
                            ],
                        });
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                    });
            } else{
                this.setState({
                    front: true,
                    loading: false,
                });
            }

        } else if(f==="minu_kuulutused" ||f=== "kuulutused_pooleli") {
            /* MINU KUULUTUSED and kuulutused_pooleli */

            this.setState({
                page: 'my_post',
                loading: false,
                front:false,
                searchBar: false
            })
            axios.get(`/count/my_post/0/`)
                .then(function (res) {
                    const reponse = res.data;
                    console.log('response' + reponse)
                    const mina_myyn = reponse.mina_myyn;
                    const pooleli_olevad = reponse.pooleli_olevad;
                    console.log(mina_myyn,pooleli_olevad)
                    this.setState({
                        tabs: [
                            {key: 1003,name:LANG['Sisestamisel'] ||  'Sisestamisel', count: pooleli_olevad, slug: "pooleli_olevad", fileName:'kuulutused_pooleli'},
                            {key: 1001, name:LANG['Pakkumisel'] ||  'Pakkumisel', count:mina_myyn, slug: "mina_myyn", fileName:'minu_kuulutused'}
                        ],
                    });
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                });
        } else if(f==="mina_myyn" || f==="mina_osalen"|| f==="pooleli_olevad") {
            /* MINU OKSJONID and  mina_osalen and pooleli_olevad */
            this.setState({
                page: 'my_auction',

                loading: false,
                front:false,
                searchBar: false
            })
            axios.get(`/count/my_auction/0/`)
                .then(function (res) {
                    const mina_myyn = res.data.mina_myyn;
                    const mina_osalen = res.data.mina_osalen;
                    const pooleli_olevad = res.data.pooleli_olevad;
                    this.setState({
                        tabs: [
                            {key: 1003,name:LANG['Sisestamisel'] || 'Sisestamisel', count: pooleli_olevad, slug: "pooleli_olevad", fileName:'pooleli_olevad'},
                            {key: 1001, name:LANG['Müün'] || 'Müün', count:mina_myyn, slug: "mina_myyn", fileName:'mina_myyn'},
                            {key: 1002, name:LANG['Ostan'] || 'Ostan', count:mina_osalen, slug: "mina_osalen", fileName:'mina_osalen'}
                        ],
                    });
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                });
        }


    }

    handleTab=(TabIndex,TabsName,fileName)=>{
        if(TabIndex === 501 || TabIndex === 502 || TabIndex === 503){
            this.setState({selectedTab: TabIndex});
            window.history.replaceState(TabIndex, TabsName, `/index.php?f=${fileName}&t=${this.state.auctionType}`);
        } else if (TabIndex === 1001 || TabIndex === 1002 || TabIndex === 1003) {
            this.setState({selectedTab: TabIndex});
            window.history.replaceState(TabIndex, TabsName, `/index.php?f=${fileName}`);
        } else {
            this.setState({selectedTab: TabIndex});
            window.history.replaceState(TabIndex, TabsName, `/index.php?f=${fileName}&t=${TabIndex}`);
        }

    }
    handleInput=(event)=> {
        let link = this.state
        if(event.target.name === 'clear'){
            this.setState({
                keyword: '',
                county: '',
                minprice: '',
                maxprice: '',
                keywordValue: '',
                countyValue: '',
                minpriceValue: '',
                maxpriceValue: '',
                sort:'',
                link: '',
                refreshTabs: !this.state.refreshTabs
            });
        } else if(event.target.name === 'keyword'){
            this.setState({
                [event.target.name + 'Value'] : event.target.value,
            });
            if(this.state.keywordValue.length > 0){
                this.setState({
                    [event.target.name]: `&${event.target.name}=${event.target.value}`,
                    link: '?'+link.keyword+link.county+link.minprice+link.maxprice+link.sort,
                    refreshTabs: !this.state.refreshTabs
                });
            }
        } else if(event.target.name === 'sort'){
            this.setState({
                [event.target.name + 'Value'] : event.target.value,
                [event.target.name]: `&${event.target.name}=${event.target.value}`,
                link: '?'+link.keyword+link.county+link.minprice+link.maxprice+link.sort,
                refreshTabs: !this.state.refreshTabs
            });
            localStorage.setItem(event.target.name,  `&${event.target.name}=${event.target.value}`)
            localStorage.setItem( `${event.target.name}Value`,  event.target.value)
            console.log(localStorage.getItem("sort"), localStorage.getItem("sortValue"))
        }else{
            this.setState({
                [event.target.name + 'Value'] : event.target.value,
                [event.target.name]: `&${event.target.name}=${event.target.value}`,
                link: '?'+link.keyword+link.county+link.minprice+link.maxprice+link.sort,
                refreshTabs: !this.state.refreshTabs
            });
        }
    }
    addToCounty=(county)=>{
        this.setState({
            filterCounty: county
        });
    }

    render(
        tabs = this.state.tabs,
        tab = this.state.selectedTab,
        page = this.state.page,
        front = this.state.front
        ) {
        if(!this.state.loading){
            if(!front){
                return (
                    <React.Fragment>
                        <nav className={'tab-menu cell large-12 medium-12 small-12 grid-x align-center'}>
                            {this.state.tabs.map((tabs) => {
                                return (
                                    <section className={tab === tabs.key ? `tab-item ${tabs.key} active` : `tab-item ${tabs.key}`} 
                                        key={tabs.key} onClick={this.handleTab.bind(this, tabs.key,tabs.name,tabs.fileName)}>
                                        {tabs.name}<span className="pill darkergreen color-white">{tabs.count}</span>
                                    </section>
                                );
                            })}
                        </nav>
                        {this.state.searchBar? <SearchBar
                            page={page}
                            handleInput={this.handleInput.bind(this)}
                            filterCounty={this.state.filterCounty}
                            keyword={this.state.keywordValue}
                            minprice={this.state.minpriceValue}
                            maxprice={this.state.maxpriceValue}
                            sort={this.state.sortValue}
                        /> : ''}
                        <section className={'cell large-12 medium-12 small-12 grid-x align-center'}>
                            {tabs.map((tabs) => {
                                if (tab === tabs.key) {
                                    if (!this.state.refreshTabs) {
                                        return <ItemList
                                            key={tabs.key}
                                            page={page}
                                            fileName={tabs.fileName}
                                            selectedTabId={tabs.key}
                                            selectedTabName={tabs.name}
                                            selectedTabSlug={tabs.slug}
                                            auctionSlug={tabs.auctionSlug}
                                            auctionType={this.state.auctionType}
                                            postType={this.state.postType}
                                            keyword={this.state.keyword}
                                            county={this.state.county}
                                            minprice={this.state.minprice}
                                            maxprice={this.state.maxprice}
                                            sort={this.state.sort}
                                            addToCounty={this.addToCounty}
                                        />
                                    } else if (this.state.refreshTabs) {
                                        return (
                                            <React.Fragment key={tabs.key}>
                                                <ItemList
                                                    key={tabs.key}
                                                    page={page}
                                                    fileName={tabs.fileName}
                                                    selectedTabId={tabs.key}
                                                    selectedTabName={tabs.name}
                                                    selectedTabSlug={tabs.slug}
                                                    auctionSlug={tabs.auctionSlug}
                                                    auctionType={this.state.auctionType}
                                                    postType={this.state.postType}
                                                    keyword={this.state.keyword}
                                                    county={this.state.county}
                                                    minprice={this.state.minprice}
                                                    maxprice={this.state.maxprice}
                                                    sort={this.state.sort}
                                                    addToCounty={this.addToCounty}
                                                />
                                            </React.Fragment>
                                        )
                                    }
                                }
                            })}
                        </section>
                    </React.Fragment>
                )
            } else if(front) {
                return (
                <Front
                    key={tabs.key}
                    page={page}
                    selectedTabId={tabs.key}
                    selectedTabName={tabs.name}
                    selectedTabSlug={tabs.slug}
                    auctionType={this.state.auctionType}
                />
                );}
        } else{
            return  <Loading/>
        }

    }
}

export default Tabs;